<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog v-model="printLabelsDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pl-3">Print Labels</v-card-title>
                <v-select
                    label="Label Type"
                    class="px-3"
                    v-model="labelType"
                    :items="['8x11', '4x6', 'Item']"
                >
                </v-select>
                <div v-if="labelType == 'Item'">
                    <v-select
                        label="Item"
                        class="px-3"
                        v-model="selectedItem"
                        :items="menuItems.map((m) => m.name)"
                    >
                    </v-select>
                </div>
                <v-select
                    label="Menu Type"
                    class="px-3"
                    v-model="menuType"
                    :items="['FULL MENU']"
                >
                </v-select>
                <v-select
                    label="Language"
                    class="px-3"
                    v-model="language"
                    :items="['ENGLISH/SPANISH', 'ENGLISH/YIDDISH']"
                >
                </v-select>
                <v-select
                    class="px-3"
                    v-model="distributionName"
                    label="Distribution"
                    :items="distributions.map((d) => d.week)"
                ></v-select>
                <v-checkbox
                    class="px-3 mt-1 mb-3"
                    v-model="markAsCompleted"
                    label="Mark As Printed"
                    color="success"
                    hide-details
                ></v-checkbox>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="printLabelsDialog = false"
                        color="default"
                        dark
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="printLabels"
                    >
                        print
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="printItemLabelsDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pl-3"
                    >Print Item Labels</v-card-title
                >
                <v-select
                    class="px-3"
                    v-model="distributionName"
                    label="Distribution"
                    :items="distributions.map((d) => d.week)"
                ></v-select>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="printItemLabelsDialog = false"
                        color="default"
                        dark
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="printItemLabels"
                    >
                        print
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        title: "Families",

        actions: [],

        regID: "",
        url: "",
        menuItems: [],
        selectedItem: "",
        labelType: "Item",
        menuType: "FULL MENU",
        language: "ENGLISH/SPANISH",
        printLabelsDialog: false,
        printItemLabelsDialog: false,
        processing: false,
        distributions: [],
        distributionName: "",
        markAsCompleted: false,

        columns: [
            {
                field: "id",
                label: "Family ID",
                link: "YkCampFamilyView",
                template: "link-cell-template",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "playName",
                label: "Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "nameY",
                label: "Hebrew Name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     field: "id",
            //     label: "Family ID",
            //     link: "YkCampFamilyView",
            //     template: "link-cell-template",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                field: "phoneNumber",
                label: "Phone Number",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "site",
                label: "Site",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "pin",
                label: "Pin",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "bungalow",
                label: "Bungalow",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "note",
                label: "Note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "labelNote",
                label: "Label Note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Allow Change",
                field: "allowChange",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Last Called At",
                field: "lastCalledAt",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "No Box",
                field: "noBox",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Is Active",
                field: "isActive",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Box Number",
                field: "boxNumber",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Date Printed",
                field: "datePrinted",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.loadMenuItems();
    },
    methods: {
        async beforeSetupGrid() {
            await this.loadDistributions();

            this.actions.push({
                text: "Select Distribution",
                type: "select",
                values: this.distributions.map((t) => t.week),
                value: this.distributionName,
                onSelected: this.onDistributionSelected,
            });

            this.actions.push({
                text: "Print Item Lables",
                name: "PrintItemLables",
                action: this.openPrintItemLabelsDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Print Labels",
                name: "PrintLabel",
                action: this.openPrintLabelsDialog,
                showOnSelection: true,
            });

            this.columns.find((c) => c.field == "id").showLink = this.showLink;

            this.url =
                "ykCampFamilies?branch=" +
                (this.getBranch() ? this.getBranch() : "") +
                "&distributionID=" +
                this.getDistributionID(this.distributionName);
        },
        async loadMenuItems() {
            const response = await this.$http.get(
                "api/campDistribution/getMenuSetupItems",
            );

            this.menuItems = response;
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        getBranch() {
            return this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
                ? this.$store.state.authentication.branch
                : "";
        },
        async onRowClicked(row) {
            if (this.getBranch()) return;

            this.$router.push({
                name: "YkCampFamilyView",
                params: { id: row.id },
                query: {
                    distributionID: this.getDistributionID(
                        this.distributionName,
                    ),
                },
            });
        },
        async loadDistributions() {
            const response = await this.$http.get(
                "api/campDistribution/GetDistributionSelectionList",
            );

            this.distributions = response;

            const first = this.distributions[0];

            this.distributionName = first.week;
        },
        onDistributionSelected(value) {
            this.distributionName = value;
            this.url =
                "ykCampFamilies?branch=" +
                (this.getBranch() ? this.getBranch() : "") +
                "&distributionID=" +
                this.getDistributionID(this.distributionName);

            this.$refs.grid.reloadDataSource(this.url);
        },
        getDistributionID(name) {
            if (!name) return null;

            return this.distributions.find((d) => d.week == name).id;
        },
        openPrintLabelsDialog() {
            this.printLabelsDialog = true;
        },
        async printLabels() {
            var grid = this.$refs.grid;

            let selected = grid.getSelectedRowsData();

            const columnSort = this.columns.find((c) => {
                const sort = this.$refs.grid.grid.columnOption(
                    c.field,
                    "sortOrder",
                );

                if (!sort) return false;

                return true;
            });

            if (columnSort) {
                const sortOrder = this.$refs.grid.grid.columnOption(
                    columnSort.field,
                    "sortOrder",
                );

                selected = selected.sort((a, b) => {
                    if (sortOrder == "desc") {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return 1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return -1;
                        }
                        return 0;
                    } else {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return -1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return 1;
                        }
                        return 0;
                    }
                });
            }

            if (!selected.length) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Families",
                    type: "error",
                });

                return;
            }

            if (!this.distributionName) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Distribution",
                    type: "error",
                });

                return;
            }

            if (this.labelType == "Item" && !this.selectedItem) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Item",
                    type: "error",
                });

                return;
            }

            const ids = selected.map((d) => d.id);

            try {
                this.processing = true;

                const response = await this.$http({
                    url: "api/campDistribution/printLables",
                    method: "POST",
                    data: {
                        selectedIDs: ids,
                        distributionID: this.getDistributionID(
                            this.distributionName,
                        ),
                        labelType: this.labelType,
                        markAsCompleted: this.markAsCompleted,
                        fullMenu: this.menuType == "FULL MENU",
                        description2Lang:
                            this.language == "ENGLISH/YIDDISH" ? 1 : 0,
                        menuItemID: this.getMenuItemID(),
                    },
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Labels.pdf");
                document.body.appendChild(link);
                link.click();

                this.$refs.grid.reloadGrid();

                this.printLabelsDialog = false;
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        getMenuItemID() {
            if (this.labelType != "Item") return;

            const menuItem = this.menuItems.find(
                (m) => m.name == this.selectedItem,
            );

            return menuItem ? menuItem.id : null;
        },
        openPrintItemLabelsDialog() {
            this.printItemLabelsDialog = true;
        },
        async printItemLabels() {
            var grid = this.$refs.grid;

            let selected = grid.getSelectedRowsData();

            if (!selected.length) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Families",
                    type: "error",
                });

                return;
            }

            if (!this.distributionName) {
                this.$notify({
                    group: "notification",
                    text: "Please Select Distribution",
                    type: "error",
                });

                return;
            }

            const ids = selected.map((d) => d.id);

            try {
                this.processing = true;

                const response = await this.$http({
                    url:
                        "api/campDistribution/printCampDistributionByItemLables",
                    method: "POST",
                    data: {
                        selectedIDs: ids,
                        distributionID: this.getDistributionID(
                            this.distributionName,
                        ),
                    },
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "ItemLabels.pdf");
                document.body.appendChild(link);
                link.click();

                this.$refs.grid.reloadGrid();

                this.printItemLabelsDialog = false;

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
